
import 'zone.js/dist/zone'; 

(window as any).global = window;
